import { render, staticRenderFns } from "./EleFormGallery.vue?vue&type=template&id=309e874a&"
import script from "./EleFormGallery.vue?vue&type=script&lang=js&"
export * from "./EleFormGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports